// extracted by mini-css-extract-plugin
export var description = "client-module--description--2988f";
export var fadeInAnimation = "client-module--fadeInAnimation--29787";
export var img = "client-module--img--d21d6";
export var location = "client-module--location--1ef41";
export var locationLabel = "client-module--locationLabel--66eb3";
export var locationName = "client-module--locationName--497db";
export var picture = "client-module--picture--130cf";
export var wrapper = "client-module--wrapper--1202e";